<template>
    <div>
        <template v-if="loadedData">
            <UserBanner />
            <router-view/>
        </template>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import UserBanner from 'components/user/UserBanner'

    export default {
        name: 'UserPage',
        data () {
            return {
                loadedData: false
            }
        },
        components: {
            UserBanner
        },
        computed: {
            ...mapGetters({
                isLoggedIn: 'isLoggedIn'
            })
        },
        watch: {
            isLoggedIn (val) {
                if (!val) {
                    this.$router.push({ 'name': 'login' })
                }
            }
        },
        async created () {
            this.loadedData = false
            await this.$store.dispatch('loadUserData').then(() => this.loadedData = true)
            if (!this.isLoggedIn) {
                this.$router.push({ 'name': 'login' })
            }
        }
    }
</script>
